<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="middle-panel" @click.stop>
                <div class="dialog-title" v-t="'message.item_two_phase_method_code'">
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body-small">
                    <div class="confirm-panel">
                        <div class="title" v-t="'message.title_check_confirmCode'"></div>
                        <div class="description">
                            <p v-html="$t('message.desc_sent_confirmCode1', { email: this.email })"></p>
                            <p v-html="$t('message.desc_sent_confirmCode2')"></p>
                        </div>
                        <div class="form-button-field">
                            <el-button class="default-button" v-on:click="sendMail(true)" v-t="'message.item_resend_code'"></el-button>
                        </div>
                        <div v-if="showCheckCode" class='check-code'>
                            <div>
                                <input
                                    v-for="index in 6"
                                    :key="index"
                                    v-model="codes[index - 1]"
                                    maxlength="1"
                                    :ref="'code' + index"
                                    @input="handleInput(index, $event)"
                                    @paste="handlePaste($event, index)"
                                    @keydown.backspace="handleBackspace(index, $event)"
                                    class="code-input"
                                />
                            </div>
                        </div>
                        <div class="confirm-message">
                            <el-collapse-transition>
                                <div v-if="errorInfo != null">
                                    <div class="confirm-error">{{ errorInfo }}</div>
                                </div>
                            </el-collapse-transition>
                        </div>
                        <div class="form-button-field">
                            <el-button class="default-button" v-on:click="clearConfirmCode" v-t="'message.button_reset'"></el-button>
                        </div>
                        <div class="confirm-message">
                            <div class="description">
                                <p v-html="$t('message.desc_check_confirmCode1')"></p>
                                <p v-html="$t('message.desc_check_confirmCode2')"></p>
                            </div>
                        </div>
                    </div>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')" v-t="'message.button_back'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Vue from 'vue'
import server from "../../../ServerApi.js";
import constants from '../../../constants.js';
import commonUtil from '../../../commonutil.js';

export default {
    props: {
        email: String,
        errorInfo: String
    },
    data() {
        return {
            showCheckCode: true,
            codes: ['', '', '', '', '', '']
        };
    },
    watch: {
        codes(confirmCodes) {
            if(confirmCodes.every(code => code !== '')) {
                this.checkConfirmCode();
            }
        }
    },
    mounted: function() {
        this.sendMail(false);
        this.showCheckCode = true;
    },
    methods: {
        checkConfirmCode() {
            let self = this;
            const confirmCode = this.codes.join('');
            const request = {
                methodOption: constants.LOGIN_METHOD_MAIL,
                email: self.email,
                emailCode: confirmCode
            }
            self.$emit('verified', request);
        },
        sendMail(resend) {
            let self = this;
            const request = {
                email: this.email,
                countryCode: (this.$i18n.locale == "ja") ? "JPN" : "",
                purpose: constants.CONFIRM_PURPOSE_TWO_PHASE_AUTH
            }
            server.post('/sendconfirmationcode', request)
            .then((res) => {
                switch(res.data.status) {
                    case constants.STATUS_SUCCESS:
                        if (resend) {
                            commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"desc_resent_code"));
                        }
                        break;
                    case  constants.STATUS_ERROR_DENIED:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_notify_mail_block"));
                        self.$emit('cancel');
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","sendMail").replace("{code}",res.data.status));
                        break;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "checkConfirmCode", error);
            });
        },
        handleInput(index, event) {
            this.$nextTick(() => {
                const key = event.target.value;
                const currentValue = this.codes[index - 1];
                const nextElement = this.$refs[`code${index + 1}`] ? this.$refs[`code${index + 1}`][0] : null;
                if (key >= '0' && key <= '9') {
                    if(currentValue !== '' && nextElement) {
                        nextElement.focus();
                    }
                }
            });
        },
        handleBackspace(index, event) {
            if (this.codes[index - 1] === '') {
                event.preventDefault();
                if (index > 1) {
                    const prevElement = this.$refs[`code${index - 1}`][0];
                    if(prevElement) {
                       prevElement.focus();
                    }
                }
            }
        },
        handlePaste(event, index) {
            const paste = (event.clipboardData || window.clipboardData).getData('text');
            if(paste) {
                const isNumeric = paste.split('').every(char => !isNaN(char) && char !== ' ');
                if (!isNumeric) {
                    event.preventDefault();
                    return;
                }        
                const pasteArray = paste.split('');
                pasteArray.forEach((char, i) => {
                    if(index + i <= 6) {
                        this.$set(this.codes, index - 1 + i, char);
                    }
                });
                this.$nextTick(() => {
                    const nextElement = this.$refs[`code${index + pasteArray.length}`] ? this.$refs[`code${index + pasteArray.length}`][0] : null;
                    if(nextElement) {
                        nextElement.focus();
                    }
                });
            }
            event.preventDefault();
        },
        clearConfirmCode() {
            this.codes = ['', '', '', '', '', ''];
            this.$nextTick(() => {
                this.$refs.code1[0].focus();
            });
        }
    }
}
</script>

<style scoped>
.middle-panel {
    background: #fff;
    position: absolute;
    padding: 0;
    left: 50%;
    top: 50%;
    width: 580px;
    max-height: 80vh;
    margin-top: -40vh;
    margin-left: -250px;
    transition: all .3s ease;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
}

.confirm-panel {
    text-align: center;
    padding-bottom: 20px;
}

.title {
    padding-top: 10px;
}

.description {
    padding-top: 10px;
    padding-bottom: 10px;
}

.confirm-message {
    padding-top: 50px;
}

.confirm-error {
    padding-bottom: 15px;
    height: 35px;
    color: #d55169;
}

.dialog-body-small {
    overflow: hidden;
}

.check-code {
    padding-top: 30px;
    padding-left: 15px;
}

.code-input {
  box-sizing: border-box;
  width: 30px;
  height: 40px;
  margin: 0 5px;
  font-size: 20px;
  text-align: center;
  border: 2px solid #ccc;
  border-radius: 5px;
  transition: border-color 0.3s;
}

.code-input:focus {
  border-color: #007bff;
  outline: none;
}

.console-logo {
    padding-top: 10px;
    padding-bottom: 10px;
    height: 36px;
}

</style>

